













































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { AuthModule } from '@/store/modules/auth.module'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Input from '@/components/inputs/Input.vue'
import Password from '@/components/inputs/Password.vue'
import Api from '@/api'
import Login from '@/views/auth/Login.vue'
import ResidentSignUp from '@/views/auth/ResidentSignUp.vue'
import { validatePassword } from '@/utils/helpers'
import { UserModule } from '@/store/modules/user.module'
import { User } from '@/classes/User'
import { ChainModule } from '@/store/modules/chain.module'
import { Dictionary, EUserStatus, IResident, ITokenPayload } from '@zunta/configurations'
import { ResidentModule } from '@/store/modules/resident.module'
import MigrateToV2Popup from './components/MigrateToV2Popup.vue'
const jwtDecode = require('jwt-decode')

@Component({
  components: {
    ResidentSignUp,
    Login,
    Input,
    Password,
    ErrorMessages,
    MigrateToV2Popup,
  }
})
export default class ResidentSignUpWithPassword extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  authModuleInstance: AuthModule = getModule(AuthModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  isLoggedIn: boolean = false
  isValidPasswords: boolean = true
  residentId: any = ''
  email: any = ''
  password: string = ''
  repeatPassword: string = ''
  backendValidationErrors: String[] = []
  isSubmitting: boolean = false
  user: User | null = null
  showMigrateToV2Popup = false
  residentChainMigrationData: Partial<IResident> | null = null;

  async mounted () {
    this.residentId = this.$route.params.resident || this.$route.query.resident
    this.email = this.$route.params.email || this.$route.query.email
    this.residentChainMigrationData = await this.residentModuleInstance.getResidentChainMigrationData(this.residentId)
    if (this.residentChainMigrationData) {
      this.showMigrateToV2Popup = true
    }
  }

  get errors () {
    return this.$store.state.auth.errors
  }

  async validateCredentials (): Promise<void> {
    const email = this.email.trim()
    const password = this.password.trim()

    if (this.residentChainMigrationData) {
      this.showMigrateToV2Popup = true
    }

    if (email && password) {
      const responseToken = await this.authModuleInstance.validateCredentials({ email, password })
      if (responseToken) {
        this.authModuleInstance.setToken(responseToken)
        const userData: ITokenPayload = jwtDecode(responseToken)
        const isCorrectUser = await this.authModuleInstance.getIsValidUser(userData)
        const canEnterChain = await this.chainModuleInstance.getCanEnterChain(userData)
        if (!isCorrectUser || !canEnterChain) {
          await Api.logout(true)
          this.$eventBus.$emit('notify', {
            color: 'var(--status-error-color)',
            message: isCorrectUser ? 'Chain is Deactivated' : 'User not properly set up',
            header: `Login`,
            icon: 'warning'
          })
          return
        }

        if (userData.status === EUserStatus.ACTIVE) {
          await this.$router.push(this.redirectUrl())
        }
        this.isLoggedIn = true
      }
    }
  }

  redirectUrl (): string {
    const user = Api.getUser()
    if (user && user.isResident()) {
      return '/app/portal/resident-general'
    }
    return '/login'
  }

  validate (): boolean {
    this.isValidPasswords = true
    this.isValidPasswords = !!(this.password === this.repeatPassword && validatePassword(this.password))
    return this.isValidPasswords
  }

  async updatePasswordAndActivate () {
    if (this.validate()) {
      this.isSubmitting = true
      const { email, password, residentId } = this
      const result = await this.userModuleInstance.updateResidentUserPassword({ email, password, residentId })

      if (result === 'OK') {
        await this.$router.push(this.redirectUrl())
      } else {
        this.backendValidationErrors = []
        this.backendValidationErrors.push(result.message)
      }
      this.isSubmitting = false
    }
  }
}
